var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"item",staticClass:"aha-storybook-dropdown-item",class:{'active': _vm.isActive},attrs:{"role":"menuitem","title":_vm.title},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }